import type { ReactNode } from 'react'
import { Item } from '@highlight/ui'
import { FileTypeIcon } from './file-type-icon'

/**
 * A file shown larger than a pill because it has a status to read or an action to take, such as one that needs
 * reattaching or one the agent offered to download.
 */
export function AttachmentCard({
  name,
  isDirectory,
  status,
  action,
}: {
  name: string
  isDirectory?: boolean
  status: ReactNode
  action?: ReactNode
}) {
  return (
    <Item variant="outline" size="sm" className="w-72 max-w-full select-none">
      <Item.Media variant="icon">
        <FileTypeIcon name={name} isDirectory={isDirectory} className="size-5" />
      </Item.Media>
      <Item.Content>
        <Item.Title>{name}</Item.Title>
        <Item.Description>{status}</Item.Description>
      </Item.Content>
      {action && <Item.Actions>{action}</Item.Actions>}
    </Item>
  )
}
